import DOMPurify from 'dompurify';

const MAINTENANCE_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'a',
  'div',
  'span',
];

const MAINTENANCE_ALLOWED_ATTR = ['href', 'target', 'rel'];

/**
 * Sanitizes HTML for the public maintenance page.
 */
export function sanitizeMaintenanceHtml(html: string): string {
  return DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS: MAINTENANCE_ALLOWED_TAGS,
    ALLOWED_ATTR: MAINTENANCE_ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
}
